import { Card, ChevronRightIcon, DesktopIcon } from "@bp/ui-components";
import { Link } from "react-router-dom";
import { useQuery } from "urql";
import { getFragmentData, graphql } from "../../../client/gql";
import css from "../../../pages/AuthClients/AuthClientDetailPage.module.scss";
import { productIdFromName } from "../../../utils/product";
import { ProductMark } from "../../brand";

// Colocated fragment: only the fields the reverse-link list renders.
const LinkedApplications_Application = graphql(`
  fragment LinkedApplications_Application on Application {
    uuid
    clientId
    name
    uri
  }
`);

const LinkedApplicationsQuery = graphql(`
  query LinkedApplications_Query($where: ApplicationWhere) {
    applications(where: $where) {
      ...LinkedApplications_Application
    }
  }
`);

/** Reverse link: the Application(s) that reference this OAuth client. */
export function LinkedApplications({ clientId }: { clientId: string }) {
  const [{ data }] = useQuery({ query: LinkedApplicationsQuery, variables: {} });
  const applications = getFragmentData(LinkedApplications_Application, data?.applications ?? []);
  const apps = applications.filter((a) => a.clientId === clientId);

  return (
    <Card contentPadding="none">
      <div className={css.cardHead}>
        <span className={css.cardHeadTitle}>
          <DesktopIcon style={{ width: 17, height: 17, color: "var(--color-primary)" }} />
          Verknüpfte Application
        </span>
      </div>
      {apps.length === 0 ? (
        <div className={css.prowEmpty}>
          Noch keiner Application zugeordnet — ein OAuth-Client gehört typischerweise zu genau einer
          Application.
        </div>
      ) : (
        <div>
          {apps.map((a) => {
            const pid = productIdFromName(a.name);
            return (
              <Link key={a.uuid} to={`/applications/${a.uuid}`} className={css.prow}>
                <span className={css.prowMark}>
                  {pid ? (
                    <ProductMark id={pid} size={18} />
                  ) : (
                    <DesktopIcon
                      style={{ width: 16, height: 16, color: "var(--color-primary-dark)" }}
                    />
                  )}
                </span>
                <span className={css.prowMain}>
                  <div className={css.prowName}>{a.name}</div>
                  <div className={css.prowMeta}>{a.uri || a.clientId}</div>
                </span>
                <ChevronRightIcon className={css.prowChev} style={{ width: 16, height: 16 }} />
              </Link>
            );
          })}
        </div>
      )}
    </Card>
  );
}
